export default function baseUrlGrader() {
    /** Ganti Base URL 
     *
     * Di Akhir Url Jangan pakai 'slash' 
     * Contoh  [x] https://localhost:9090/
     *         [v] https://localhost:9090
    **/

    // return "https://dev-backend.birutekno.com"
    // return "https://37.44.244.162:9090";
    return process.env.VUE_APP_BASE_URL_GRADER;
    // return "http://103.214.113.160:9093"
    // return "http://192.168.1.16:9091"
    
    // return "http://localhost:9092"
    // return "http://localhost:9090"
    // return "https://192.168.1.17:7887"
    // return "https://192.168.0.117:2325"
}   